import React, { memo } from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
var Header = function Header(_ref) {
  var text = _ref.text,
    customClass = _ref.customClass;
  return /*#__PURE__*/React.createElement("div", {
    className: "andes-header ".concat(customClass)
  }, text);
};
Header.propTypes = {
  text: PropTypes.string.isRequired,
  customClass: PropTypes.string
};
Header.defaultProps = {
  customClass: ''
};
export default compose(memo)(Header);